export var sanitizeOrganizationId = function sanitizeOrganizationId(orgId) {
    if (!orgId) {
        return undefined;
    }
    return orgId.replace(/[^a-zA-Z0-9-]/g, '');
};
export var sanitizeHostedSearchPageId = function sanitizeHostedSearchPageId(searchPageId) {
    if (!searchPageId) {
        return undefined;
    }
    return searchPageId.replace(/[^a-zA-Z0-9\-]/g, '');
};
export var sanitizeClassicHostedSearchPageName = function sanitizeClassicHostedSearchPageName(searchPageName) {
    if (!searchPageName) {
        return undefined;
    }
    return searchPageName.replace(/[^a-zA-Z0-9\-_]/g, '');
};
export var sanitizeRegion = function sanitizeRegion(region) {
    if (!region) {
        return undefined;
    }
    return region.replace(/[^a-zA-Z]/g, '');
};

//# sourceMappingURL=Sanitization.js.map